import { CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material"
import { ReactNode } from "react"
import info from "../../assets/info.svg"

interface DialogProp {
    open: boolean
    content: string
    title: string
    onClose: (event: object, reason: 'backdropClick' | 'escapeKeyDown') => void
    children: ReactNode
}

function ErrorDialog(props: DialogProp) {
    const {open, content, title, children, onClose} = props

    return (
        <Dialog open={ open } onClose={ onClose } fullWidth>
            <CardMedia
                sx={ {width: `10%`, objectFit: `contain`, marginLeft: `auto`, marginRight: `auto`, marginTop: `1vh`} }
                component="img"
                image={ info }
                alt="Disclaimer Banner"
            />
            { title && <DialogTitle sx={ {textAlign: `center`} }>
                { title }
            </DialogTitle> }
            <DialogContent>
                <DialogContentText sx={ {textAlign: `center`} }>
                    { content }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="space-around" spacing={ 2 } rowSpacing={ 2 }>
                    { children }
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default ErrorDialog
